import * as Promise from 'bluebird';

/**
 * preload data for the game
 */
export function preload() : Promise<void>
{
    return Promise.delay(200);
}


// WEBPACK FOOTER //
// ./src/ts/preloader/Preload.ts